export default "assets/images/icons/close-9eeaf7ea.svg";